import { combineReducers } from 'redux';
import {
  LIBRARY_ITEM_HUB_SET_FILTER_STATE,
  LIBRARY_ITEM_HUB_SET_OUTLETS,
  LIBRARY_ITEM_HUB_SET_REWARD_ITEM_LIST,
  LIBRARY_ITEM_HUB_SET_REWARD_CATEGORY_LIST,
  LIBRARY_ITEM_HUB_SET_REWARD_ITEM_VARIANT_OF,
  LIBRARY_ITEM_HUB_SET_POINT_GAIN_ITEM_LIST,
  LIBRARY_ITEM_HUB_SET_POINT_GAIN_CATEGORY_LIST,
  LIBRARY_ITEM_HUB_SET_POINT_GAIN_ITEM_VARIANT_OF,
  LIBRARY_ITEM_HUB_SET_ITEM_LIST,
  LIBRARY_ITEM_HUB_SET_META_ITEMS,
  LIBRARY_ITEM_HUB_TOGGLE_WRITE_MODE,
  LIBRARY_ITEM_HUB_SET_ITEM_DETAIL,
  LIBRARY_ITEM_HUB_SET_CATEGORY_LIST,
  LIBRARY_ITEM_HUB_SET_PREVIOUS_ITEM_FORM,
  LIBRARY_ITEM_HUB_SET_MODIFIERS,
  LIBRARY_ITEM_HUB_SHOW_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HUB_HIDE_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HUB_SHOW_SALES_TYPE_MODAL,
  LIBRARY_ITEM_HUB_HIDE_SALES_TYPE_MODAL,
  LIBRARY_ITEM_HUB_SHOW_MODIFIER_MODAL,
  LIBRARY_ITEM_HUB_HIDE_MODIFIER_MODAL,
  LIBRARY_ITEM_HUB_SHOW_DELETE_MODAL,
  LIBRARY_ITEM_HUB_HIDE_DELETE_MODAL,
  LIBRARY_ITEM_HUB_SHOW_CONFIRM_ITEM_MODAL,
  LIBRARY_ITEM_HUB_HIDE_CONFIRM_ITEM_MODAL,
  LIBRARY_ITEM_HUB_SET_CHANNEL_ASYNC_JOB,
  LIBRARY_ITEM_HUB_SET_LIST_OUTLET_FORM,
} from 'actions/businessLibrary/item/constants';
import createReducer from 'utils/createReducer';

const categories = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_CATEGORY_LIST]: (draft, { payload }) =>
    payload.categories,
});

const outlets = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_OUTLETS]: (_, { payload }) => payload.outlets,
});

const filterState = createReducer(
  { categoryId: 0, outletId: 0, typeInventoryId: 0, keyword: '' },
  {
    [LIBRARY_ITEM_HUB_SET_FILTER_STATE]: (_, { payload }) => ({
      categoryId: payload.categoryId,
      outletId: payload.outletId,
      typeInventoryId: payload.typeInventoryId,
      keyword: payload.keyword,
    }),
  }
);

const rewardItemList = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_REWARD_ITEM_LIST]: (_, { payload }) => payload.items,
});

const rewardCategoryList = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_REWARD_CATEGORY_LIST]: (draft, { payload }) =>
    payload.categories,
});

const rewardItemVariantOf = createReducer(
  {},
  {
    [LIBRARY_ITEM_HUB_SET_REWARD_ITEM_VARIANT_OF]: (draft, { payload }) =>
      payload.itemVariants,
  }
);

const pointGainItemList = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_POINT_GAIN_ITEM_LIST]: (_, { payload }) =>
    payload.items,
});

const pointGainCategoryList = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_POINT_GAIN_CATEGORY_LIST]: (_, { payload }) =>
    payload.categories,
});

const pointGainItemVariantOf = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_POINT_GAIN_ITEM_VARIANT_OF]: (draft, { payload }) =>
    payload.itemVariants,
});

const items = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_ITEM_LIST]: (_, { payload }) => payload.items,
});

const modifiers = createReducer([], {
  [LIBRARY_ITEM_HUB_SET_MODIFIERS]: (draft, { payload }) => payload.modifiers,
});

const itemMeta = createReducer(
  {},
  {
    [LIBRARY_ITEM_HUB_SET_META_ITEMS]: (_, { payload }) => payload.meta,
  }
);

const isWriteMode = createReducer(false, {
  [LIBRARY_ITEM_HUB_TOGGLE_WRITE_MODE]: (_, { payload }) => payload.writeMode,
});

const itemDetail = createReducer(null, {
  [LIBRARY_ITEM_HUB_SET_ITEM_DETAIL]: (draft, { payload }) => payload.item,
});

const previousItemForm = createReducer(
  {
    name: null,
    category: null,
    itemVariant: [],
    itemInventory: [],
    itemModifier: [],
    description: null,
  },
  {
    [LIBRARY_ITEM_HUB_SET_PREVIOUS_ITEM_FORM]: (draft, { payload }) => ({
      ...payload.previousItemForm,
    }),
  }
);

const showItemVariantModal = createReducer(false, {
  [LIBRARY_ITEM_HUB_SHOW_ITEM_VARIANT_MODAL]: () => true,
  [LIBRARY_ITEM_HUB_HIDE_ITEM_VARIANT_MODAL]: () => false,
});

const showSalesTypeModal = createReducer(false, {
  [LIBRARY_ITEM_HUB_SHOW_SALES_TYPE_MODAL]: () => true,
  [LIBRARY_ITEM_HUB_HIDE_SALES_TYPE_MODAL]: () => false,
});

const showModifierModal = createReducer(false, {
  [LIBRARY_ITEM_HUB_SHOW_MODIFIER_MODAL]: () => true,
  [LIBRARY_ITEM_HUB_HIDE_MODIFIER_MODAL]: () => false,
});

const showDeleteModal = createReducer(false, {
  [LIBRARY_ITEM_HUB_SHOW_DELETE_MODAL]: () => true,
  [LIBRARY_ITEM_HUB_HIDE_DELETE_MODAL]: () => false,
});

const showConfirmItemModal = createReducer(false, {
  [LIBRARY_ITEM_HUB_SHOW_CONFIRM_ITEM_MODAL]: () => true,
  [LIBRARY_ITEM_HUB_HIDE_CONFIRM_ITEM_MODAL]: () => false,
});

const eventAsyncJob = createReducer(
  {
    channelName: null,
  },
  {
    [LIBRARY_ITEM_HUB_SET_CHANNEL_ASYNC_JOB]: (_, { payload }) => ({
      ...payload,
    }),
  }
);

const outletList = createReducer(
  {
    outlets: [],
    page: null,
    totalpage: null,
  },
  {
    [LIBRARY_ITEM_HUB_SET_LIST_OUTLET_FORM]: (_, { payload }) => ({
      ...payload,
    }),
  }
);

export default combineReducers({
  categories,
  outlets,
  filterState,
  eventAsyncJob,
  outletList,
  rewardItemList,
  rewardCategoryList,
  rewardItemVariantOf,
  pointGainItemList,
  pointGainCategoryList,
  pointGainItemVariantOf,
  items,
  modifiers,
  itemMeta,
  isWriteMode,
  itemDetail,
  previousItemForm,
  showItemVariantModal,
  showSalesTypeModal,
  showModifierModal,
  showDeleteModal,
  showConfirmItemModal,
});
